export * from './jotto-onboard.component';
